var _mask, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_10406_209593",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2H9C10.1046 2 11 2.89543 11 4V5H5V4C5 2.89543 5.89543 2 7 2ZM3 5.55836V5.11111V4C3 1.79086 4.79086 0 7 0H9C11.2091 0 13 1.79086 13 4V5.11111V5.55836C13.6089 6.03722 14 6.78063 14 7.61538V13.3846C14 14.8291 12.8291 16 11.3846 16H4.61538C3.17095 16 2 14.8291 2 13.3846V7.61539C2 6.78063 2.39107 6.03722 3 5.55836Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5V7H13V5H11ZM5 5H3V7H5V5ZM3 5.55836L4.2363 7.13048L5 6.52991V5.55836H3ZM13 5.55836H11V6.52991L11.7637 7.13048L13 5.55836ZM9 0H7V4H9V0ZM13 4C13 1.79086 11.2091 0 9 0V4V4H13ZM13 5V4H9V5H13ZM5 7H11V3H5V7ZM3 4V5H7V4H3ZM7 0C4.79086 0 3 1.79086 3 4H7V4V0ZM1 5.11111V5.55836H5V5.11111H1ZM1 4V5.11111H5V4H1ZM7 -2C3.68629 -2 1 0.686288 1 4H5C5 2.89543 5.89543 2 7 2V-2ZM9 -2H7V2H9V-2ZM15 4C15 0.68629 12.3137 -2 9 -2V2C10.1046 2 11 2.89543 11 4H15ZM15 5.11111V4H11V5.11111H15ZM15 5.55836V5.11111H11V5.55836H15ZM11.7637 7.13048C11.9112 7.24647 12 7.41999 12 7.61538H16C16 6.14127 15.3067 4.82796 14.2363 3.98624L11.7637 7.13048ZM12 7.61538V13.3846H16V7.61538H12ZM12 13.3846C12 13.7245 11.7245 14 11.3846 14V18C13.9336 18 16 15.9336 16 13.3846H12ZM11.3846 14H4.61538V18H11.3846V14ZM4.61538 14C4.27552 14 4 13.7245 4 13.3846H0C0 15.9336 2.06638 18 4.61538 18V14ZM4 13.3846V7.61539H0V13.3846H4ZM4 7.61539C4 7.41999 4.08881 7.24647 4.2363 7.13048L1.7637 3.98624C0.693338 4.82796 0 6.14127 0 7.61539H4Z",
    fill: "#FFFF00",
    mask: "url(#path-1-inside-1_10406_209593)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/Locked.14512edb.svg";
export { ForwardRef as ReactComponent };